import { NewJoinersAndAllocationsModalContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewJoinersAndAllocationsModal/NewJoinersAndAllocationsModal';
import { ConfirmationModalV3 } from '@dealstack/frontend/shared/components/ConfirmationModal/ConfirmationModalV3';
import { NotificationBox } from '@dealstack/frontend/shared/components/NotificationBox/NotificationBox';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import {
	useTranslationDefault,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Flex } from '@mantine/core';
import { memo, useContext } from 'react';
import styled from 'styled-components';
import { IAlertProps } from '@dealstack/frontend/shared/components/Alert/Alert.types';

const NewJoinersAndAllocationsInvestorsSummary = () => {
	const tMipManage = useTranslationMipManage();
	const newJoinersModalController = useContext(NewJoinersAndAllocationsModalContext);
	const tDefault = useTranslationDefault();

	let state: IAlertProps['state'] = 'success';

	let title = newJoinersModalController.isNewJoinersModal
		? tMipManage('confirmation_modal.new_joiner.title')
		: tMipManage('confirmation_modal.allocation.title');

	let bodyText = newJoinersModalController.isNewJoinersModal
		? tMipManage('confirmation_modal.new_joiner.description')
		: tMipManage('confirmation_modal.allocation.description');

	if (!newJoinersModalController.isMIP1200CaseValid) {
		title = tDefault(`error_codes.11010913`);
		state = 'dangerV3';
		bodyText = '';
	}

	return (
		<ConfirmationModalV3
			title={title}
			description={bodyText}
			state={state}
			children={
				<Flex gap="xs">
					<Button
						size="md"
						variant="secondary"
						onClick={newJoinersModalController?.onPreviousStepClicked}
						disabled={newJoinersModalController.isCompleting}
					>
						{tMipManage('confirmation_modal.back')}
					</Button>
					<UIElementIdentifier
						identifier={
							TEST_ELEMENT_IDS.NEW_JOINERS_AND_ALLOCATIONS_COMPLETE_SETUP_BUTTON
						}
					>
						<Button
							onClick={newJoinersModalController?.onComplete}
							variant="ghost"
							disabled={
								newJoinersModalController.isCompleting ||
								!newJoinersModalController.isMIP1200CaseValid
							}
						>
							{tMipManage('confirmation_modal.complete_setup')}
						</Button>
					</UIElementIdentifier>
				</Flex>
			}
		/>
	);
};

const Memoized = memo(NewJoinersAndAllocationsInvestorsSummary);
const Styled = styled(Memoized)`
	${NotificationBox} {
		margin-top: 1rem;
	}
`;

export { Styled as NewJoinersAndAllocationsInvestorsSummary };
